var React = require('react');
var ReactNative = require('react-native');

var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager');
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpIconButton = require('./ReUpIconButton.js');
var ShadowView = require('./ShadowView.js');
var ReUpText = require('./ReUpText');
var ReUpButton = require('./ReUpButton');
var QRCodeView = require('./QRCodeView');
var AddToWalletButton = require('./AddToWalletButton');
var createReactClass = require('create-react-class');
var MK = require('./wrappers/react-native-material-kit-wrapper');

var {
  MKSpinner
} = MK;

var {
  View,
  WebView,
  TouchableWithoutFeedback,
  StyleSheet,
  Image
} = ReactNative;

var MyCard = createReactClass(
{
  getDefaultProps : function()
  {
    return {
    }
  },

  getInitialState : function()
  {
    return {
      qrData:this.getQRDataFromUser(this.props.appManager.currentUser())
    }
  },

  _context: 0,
  componentDidMount : function()
  {
    this.props.appManager._eventEmitter.on('checkUserChanged', this.checkUserChanged, this._context++);
  },

  componentWillUnmount : function()
  {
    this.props.appManager._eventEmitter.removeListener('checkUserChanged', this.checkUserChanged, this._context);
  },

  getQRDataFromUser : function(user)
  {
    if( user == null ) return "";

    var data = {
      "U":user[ModelConstants.UserID],
      "T":"GC",
      "H":user[ModelConstants.Hash]
    };

    var dataJsonString = JSON.stringify(data);
    var dataBase64 = btoa(dataJsonString);

    return dataBase64;
  },

  _loggedInRendered : null,
  _oldHash : null,
  _oldDollars : null,
  checkUserChanged : function()
  {
    var appManager = this.props.appManager;
    var loggedIn = this.props.appManager.isLoggedIn();
    if( loggedIn )
    {

    }
  },

  didUpdate : function(data)
  {
    var thisThing = this;

  },

  render: function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = appManager.getLocalizationManager();

    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var headerColor = appManager.getColorForKey("HeaderColor");
    var headerIconColor = appManager.getColorForKey("HeaderIconColor");

    var stripHeight = this.props.initialLayout.width * 123 / 375;

    var dimension = Math.min(this.props.initialLayout.width-100, this.props.initialLayout.height-120-stripHeight);

    var stripImage = appManager.absoluteResourceForPath("MyCard/strip.png");
    var headerImage = appManager.absoluteResourceForPath("Feed/header.png");

    return(
      <View style={[styles.container, {backgroundColor:headerColor, height:this.props.initialLayout.height, width:this.props.initialLayout.width}]}>
        <View style={{width:this.props.initialLayout.width, height:stripHeight, backgroundColor:headerIconColor}}>
          <Image style={{width:this.props.initialLayout.width, height:stripHeight}} resizeMode={"cover"} source={{uri: stripImage}} />
          <View style={{position:'absolute', top:20, left:20, right:20, bottom:20}}>
            <Image style={{width:'100%', height:stripHeight-40}} resizeMode={"contain"} source={{uri: headerImage}} />
          </View>
        </View>
        <View style={{flex:1}} />
        <QRCodeView ref="qrcode" key="qrcode" data={this.state.qrData} dimension={dimension}
          style={{
            alignItems:'center',
            backgroundColor:generalColor,
            borderRadius:8,
            alignSelf:'center',
            overflow:'hidden'
          }}
          positiveColor={'black'} negativeColor={'white'}
          spinnerView={<MKSpinner style={{alignSelf : 'center',backgroundColor : 'transparent'}} strokeColor={[generalTitleColor]} />} />
        <View style={{flex:1}} />
        <View style={{alignItems:'center', justifyContent:'center'}}>
          <AddToWalletButton appManager={appManager} style={{margin:8, width:140, height:44}} />
        </View>
        <View style={{flex:1}} />
      </View>
    )
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
    flexBasis:'auto'
  },
})
MyCard.dataDependencies = ["Users"];

module.exports = MyCard;



// WEBPACK FOOTER //
// ./src/MyCard.js